<template>
  <div id="AlertEditing">
    <div class="modal-card fixed-width">
      <!-- Modal Title -->
      <header class="modal-card-head">
        <p class="modal-card-title">Incompleted Fact Finding</p>
      </header>
      <!-- Modal Description + Input -->
      <section class="modal-card-body">
        <div class="media">
          <div class="media-content">
            <!-- Modal Description -->
            <p>
              Do you really want to leave? If you leave
              <b>all filled or changed data will unsave</b>.
            </p>
          </div>
        </div>
      </section>
      <!-- Modal Footer -->
      <footer class="modal-card-foot" style="justify-content: flex-end">
        <b-button
          outlined
          class="prompt-font"
          type="is-primary"
          @click.prevent="rejectToLeave()"
        >
          ยกเลิก
        </b-button>
        <b-button
          class="prompt-font"
          type="is-primary"
          @click.prevent="confirmToLeave()"
        >
          ยืนยัน
        </b-button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertEditing",
  methods: {
    rejectToLeave: function() {
      this.$emit("rejected");
      this.$emit("close");
    },
    confirmToLeave: function() {
      this.$emit("confirmed");
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 420px;
  padding: 0 20px;
}
</style>
